// extracted by extract-css-chunks-webpack-plugin
module.exports = {"distributorNoteWrapper":"app-components-interestform-formcomponents-distributornote-distributornote--distributorNoteWrapper"};